import { useContractReads } from 'wagmi';
import { formatEther } from 'viem';
import { CONTRACT_ADDRESS, CONTRACT_ABI } from '../config/contract';

export function TokenInfo() {
  const { data: tokenInfo } = useContractReads({
    contracts: [
      {
        address: CONTRACT_ADDRESS,
        abi: CONTRACT_ABI,
        functionName: 'totalSupply',
      },
      {
        address: CONTRACT_ADDRESS,
        abi: CONTRACT_ABI,
        functionName: 'MAX_SUPPLY',
      },
    ],
    watch: true,
  });

  const formatWholeNumber = (value) => {
    if (!value) return '0';
    const number = Number(formatEther(value));
    return Math.floor(number).toLocaleString();
  };

  return (
    <div className="card token-info-card">
      <h2>Token Information</h2>
      <div className="mint-info-grid">
        <div className="mint-stat">
          <span>Name</span>
          <span>BitMemeCoin</span>
        </div>
        <div className="mint-stat">
          <span>Symbol</span>
          <span>$BMC</span>
        </div>
        <div className="mint-stat">
          <span>Current Supply</span>
          <span>{formatWholeNumber(tokenInfo?.[0]?.result)} BMC</span>
        </div>
        <div className="mint-stat">
          <span>Max Supply</span>
          <span>21,000,000 BMC</span>
        </div>
        <div className="mint-stat">
          <span>Current Price</span>
          <span className="coming-soon">Coming Soon!</span>
        </div>
        <div className="mint-stat">
          <span>Market Cap</span>
          <span className="coming-soon">Coming Soon!</span>
        </div>
      </div>
      <div className="token-info-footer">
        <a 
          href={`https://snowtrace.io/address/${CONTRACT_ADDRESS}`}
          target="_blank"
          rel="noopener noreferrer"
          className="contract-link"
        >
          Click here to view contract on Snowtrace
        </a>
      </div>
    </div>
  );
} 